import type { AnimationGroup, DeepPartial } from "@/types";

const planarSummoningCreatureAnimationOverrides: DeepPartial<AnimationGroup> = {
  targetedAnimations: [
    {
      animation: {
        name: "visibility",
        property: "material.opacity",
      },
    },
    {
      animation: {
        name: "visibility",
        property: "material.opacity",
      },
    },
    {
      animation: {
        name: "visibility",
        property: "material.opacity",
      },
    },
  ],
};

export const animationOverrides: Record<
  string,
  Record<string, DeepPartial<AnimationGroup>>
> = {
  // Red Dragon
  "05701": {
    dragonMaxRoll: {
      targetedAnimations: [
        {
          animation: {
            name: "scale",
            keys: [
              {},
              {
                frame: 10,
                // doubling the scale to correct the dragon size against the die
                values: [200, 200, 200],
              },
            ],
          },
        },
      ],
    },
  },
  // Themberchaud
  "04601": {
    dragonMaxRoll: {
      targetedAnimations: [
        {
          animation: {
            name: "scale",
            keys: [
              {},
              {
                frame: 10,
                // doubling the scale to correct the dragon size against the die
                values: [40, 40, 40],
              },
            ],
          },
        },
      ],
    },
  },
  // Upside Down
  "07501": {
    fuzUVOffset: {
      targetedAnimations: [
        {
          targetId: "Clone of d4_Fuzz.d4_Fuzz",
        },
      ],
    },
    rollCompleteFuz: {
      targetedAnimations: [
        {},
        {
          targetId: "Clone of d4_primitive2.d4_primitive2",
        },
        {},
        {
          targetId: "Clone of d6_primitive2.d6_primitive2",
        },
        {},
        {},
        {},
        {
          targetId: "Clone of d10_primitive2.d10_primitive2",
        },
        {},
        {},
        {},
        {},
        {},
        {
          targetId: "Clone of d00_primitive2.d00_primitive2",
        },
      ],
    },
  },
  // Everlasting Rime
  "01201": {
    removalDieMaterial: {
      targetedAnimations: [
        // replacing unsupported material.clearCoat.tintColor with albedoColor
        // to make sure die node turns white on dieRemoved
        {
          animation: {
            property: "material.albedoColor",
            keys: [
              {
                frame: 0,
                values: [0.0, 0.0, 0.0],
              },
              {
                frame: 10,
                values: [1, 1, 1],
              },
            ],
          },
        },
        {},
        {},
        {},
        {},
      ],
    },
  },
  // Ancient Gold Dragon
  "07001": {
    diceDissolve: {
      targetedAnimations: [
        {},
        {
          animation: {
            name: "scale",
            property: "scaling",
            keys: [
              {
                frame: 30,
                values: [1, 1, 1],
              },
              {
                frame: 45,
                values: [0, 0, 0],
              },
            ],
          },
        },
      ],
    },
  },
  // Planar Summoning
  "03001": {
    dreadnoughtMinRoll: planarSummoningCreatureAnimationOverrides,
    elderBrainMinRoll: planarSummoningCreatureAnimationOverrides,
    nightwalkerMinRoll: planarSummoningCreatureAnimationOverrides,
    kirinMaxRoll: planarSummoningCreatureAnimationOverrides,
    flailSnailMaxRoll: planarSummoningCreatureAnimationOverrides,
    marutMaxRoll: planarSummoningCreatureAnimationOverrides,
  },
};
